<!--  -->
<template>
  <div style="margin-bottom: 80px">
    <img style="width: 100%" src="@/../static/img/news.jpg" alt="" />
    <div class="total">
      <div
        class="content"
        @click="goNews(item.url)"
        v-for="item in newsData"
        :key="item.time"
      >
        <div class="content-time">新闻 {{ item.time }}</div>
        <div
          style="
            height: 2.4rem;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
          "
        >
          <img class="content-img" :src="item.imgurl" alt="" />
        </div>
        <div class="content-title">{{ item.title }}</div>
        <div class="content-title2">{{ item.title2 }}</div>
      </div>
    </div>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="6"
      layout="total, prev, pager, next, jumper"
      :total="totalData.length"
    >
    </el-pagination>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      currentPage: 1,
      newsData: [],
      totalData: [],
    };
  },

  components: {},

  computed: {},

  mounted() {
    axios
      .get("https://pub-oss.comtcare.com/official-website/news/data.json", {})
      .then((res) => {
        let data = eval("(" + res.data + ")");
        this.totalData = data.data;
        this.handleCurrentChange(1);
        // for (let index = 0; index < 6; index++) {
        //   this.newsData.push(data.data[index]);
        // }
      });
  },

  methods: {
    handleCurrentChange(val) {
      this.newsData = [];
      for (let index = (val - 1) * 6; index < val * 6; index++) {
        if (this.totalData[index]) {
          this.newsData.push(this.totalData[index]);
        }
      }
      // console.log(`当前页: ${val}`, this.newsData);
    },
    goNews(url) {
      window.open(url);
      //   window.location.href = url;
    },
  },
};
</script>
<style rel='stylesheet/less' lang='less' scoped>
.total {
  display: flex;
  flex-wrap: wrap;
  // justify-content: flex-start;
  width: 15rem;
  height: 10rem;
  margin: 60px auto;
}
.content {
  width: 4rem;
  margin: 20px 0.5rem;
  cursor: pointer;
  .content-time {
    color: #b9b7b7;
    font-size: 0.14rem;
    width: 100%;
    text-align: left;
    border-bottom: 1px solid #b9b7b7;
    margin-bottom: 20px;
    padding-bottom: 5px;
  }
  .content-title {
    font-size: 0.18rem;
    text-align: left;
    margin: 20px 0;
    line-height: 30px;
  }
  .content-title2 {
    color: #b9b7b7;
    text-align: left;
    font-size: 0.14rem;
  }
  .content-img {
    width: 100%;
    transition: all 0.3s;
  }
  .content-img:hover {
    width: 110%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/news.vue